
import Vue from 'vue';

export default Vue.extend({
	name: 'IsBoundToBudgetBadge',
	props: {
		allotmentSettings: { type: Object, default: null },
	},
});
